import React from "react"
import { useTranslation } from "react-i18next"
import QrReader from "modern-react-qr-reader"

import { useAlert } from "hooks"

// WARNING in localhost with React.StrictMode (React 18), component render twice => load() error when launch QrReader
// To test component remove <React.StrictMode> tags in index.js file

import "./QRCodeScanner.scoped.scss"

export type QRCodeScannerProps = {
	delay?: number
	classname?: string
	facingMode?: string
	onFound?: (data: string) => void
}

export const QRCodeScanner: React.FC<QRCodeScannerProps> = React.memo(
	({ delay = 500, classname = "", facingMode = "environment", onFound }) => {
		const { alert } = useAlert()
		const { t } = useTranslation()
		const qrreader = React.useRef(null)

		const onScanHandler = (data) => {
			if (data) onFound(data)
		}

		React.useEffect(() => {
			// Clean on unmount
			return () => {
				qrreader.current = null
			}
		}, []) // eslint-disable-line

		return (
			<QrReader
				className={`qr-reader flex flex-col flex-1 ${classname}`}
				delay={delay}
				facingMode={facingMode}
				onError={(error) => {
					if (error.message === "Permission denied")
						alert("error", t("searchBike.scanErrorCamera", { ns: "bike" }))
				}}
				onScan={onScanHandler}
				style={{ width: "100%" }}
				ref={qrreader}
			/>
		)
	}
)
